import { PRODUCT_UPDATE } from '../../../ActionsConst';

export const productUpdate = (product, meta) => ({
  type: PRODUCT_UPDATE,
  product,
  meta,
});
